import { marked } from "marked";
export interface ControlDescriptionSection {
  id: string;
  title: string;
  content: string;
}

export interface ControlDescriptionParserOutput {
  sections: ControlDescriptionSection[];
}

/**
 * Parses markdown text into control description sections.
 * @param markdownText The markdown text to parse.
 * @returns The parsed control description sections.
 */
export function parseControlDescriptionMarkdown(
  markdownText: string,
  idGenerator: () => string = () => crypto.randomUUID(),
): ControlDescriptionParserOutput {
  const tokens = marked.lexer(markdownText);
  const sections: ControlDescriptionSection[] = [];
  let currentSection: ControlDescriptionSection | null = null;

  for (const token of tokens) {
    if (token.type === "heading" && token.depth === 1) {
      if (currentSection) {
        currentSection.content = currentSection.content.trim();

        sections.push(currentSection);
      }
      currentSection = {
        id: idGenerator(),
        title: token.text,
        content: "",
      };
    } else if (currentSection) {
      currentSection.content += `${token.raw}`;
    }
  }
  if (currentSection) {
    // Trim newlines from the content
    currentSection.content = currentSection.content.trim();
    sections.push(currentSection);
  }
  return {
    sections,
  };
}
